/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2026-03-04 21:26:41
 * @LastEditTime: 2026-06-20 19:35:36
 * @Description: i18n initialization
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local';
import { getLanguageFromPath } from '../utils/languageRouting';

const FALLBACK_LANGUAGE = 'hk';

function normalizeDetectedLanguage(lng?: string | null) {
  if (!lng) return FALLBACK_LANGUAGE;

  const language = lng.toLowerCase().replace('_', '-');

  if (language === 'vn' || language.startsWith('vi')) return 'vn';
  if (language.startsWith('zh-tw')) return 'hk';
  if (language.startsWith('zh-hk')) return 'hk';
  if (language.startsWith('zh-cn')) return 'cn';
  if (language.startsWith('zh-hans')) return 'cn';
  if (language.startsWith('zh')) return 'hk';
  if (language.startsWith('ja')) return 'jp';
  if (language.startsWith('ko')) return 'kr';
  if (language.startsWith('th')) return 'th';
  if (language.startsWith('de')) return 'de';
  if (language.startsWith('fr')) return 'fr';
  if (language.startsWith('it')) return 'it';
  if (language.startsWith('es')) return 'es';
  if (language.startsWith('ug')) return 'ug';
  if (language.startsWith('en')) return 'en';

  return FALLBACK_LANGUAGE;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Honour explicit language URLs before the first render and API request.
    lng: typeof window === 'undefined' ? undefined : getLanguageFromPath(window.location.pathname, __BASE_PATH__) || undefined,
    fallbackLng: { vn: ['en'], default: [FALLBACK_LANGUAGE] },
    supportedLngs: ['hk', 'cn', 'en', 'jp', 'kr', 'th', 'vn', 'de', 'fr', 'it', 'es', 'ug'],
    nonExplicitSupportedLngs: false,

    resources: messages,

    // Translation files use flat keys, e.g. "features.lmd", "nav.home".
    keySeparator: false,

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeDetectedLanguage,
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
